import PartyTarget from "../../../model/character/PartyTarget";
import MineControl from "../../../model/control/MineControl";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import MineControlView from "./control/MineControlView";

export default class RowContainerMineControl extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {MineControl} mineControl
     * @param {PartyTarget} partyTarget
     */
    constructor(parentId, elementId, mineControl, partyTarget) {
        super(parentId, elementId);

        this.addView(new MineControlView(elementId, mineControl, partyTarget))
    }

    /**
     * @override
     */
    initializeView() {
  
        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'bottom-row-mine-control');

        super.initializeView();        
    }
}